import ChatIcon from '@mui/icons-material/Chat';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const ContactMessagesPlaceholder: React.FC = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.contactMessagesPlaceholder}>
      <Stack gap={4} alignItems={'center'} sx={{ maxWidth: '400px' }}>
        <ChatIcon className={classes.icon} />
        <Typography className={classes.greyText} align={'center'}>
          {t('campaignMessagesPlaceholder')}
        </Typography>
      </Stack>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  contactMessagesPlaceholder: {
    width: '100%',
    height: '100%',
    borderRadius: '12px',
    background: '#FFF',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    fontSize: theme.typography.pxToRem(70),
    color: theme.palette.greys.light,
  },
  greyText: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.greys.medium,
  },
}));

export default ContactMessagesPlaceholder;
